module.exports = __webpack_public_path__ + "static/20211221-banner-micanga-fimo-3cab34fe1bf662b8e000f5b94ec4f47f.webp";